var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpnEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
    fill: "#B4B6B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0081 11.1844C21.7678 9.26625 20.1586 7.63688 18.3548 6.47203C16.3593 5.18203 14.1562 4.5 11.984 4.5C9.9909 4.5 8.03105 5.06953 6.15886 6.19266C4.24965 7.33781 2.51996 9.01078 1.01761 11.1647C0.848014 11.4081 0.754608 11.6965 0.749266 11.9931C0.743924 12.2897 0.826888 12.5813 0.987615 12.8306C2.22558 14.768 3.81886 16.3997 5.59449 17.5486C7.59371 18.8438 9.74527 19.5 11.984 19.5C14.1736 19.5 16.3814 18.8236 18.3684 17.5444C20.1712 16.3833 21.7771 14.7478 23.0128 12.8137C23.168 12.5702 23.25 12.2872 23.2492 11.9984C23.2483 11.7096 23.1647 11.4271 23.0081 11.1844ZM12 16.5C11.1099 16.5 10.2399 16.2361 9.49989 15.7416C8.75987 15.2471 8.18309 14.5443 7.8425 13.7221C7.50191 12.8998 7.41279 11.995 7.58642 11.1221C7.76006 10.2492 8.18864 9.44736 8.81798 8.81802C9.44731 8.18868 10.2491 7.7601 11.1221 7.58647C11.995 7.41283 12.8998 7.50195 13.722 7.84254C14.5443 8.18314 15.2471 8.75991 15.7416 9.49993C16.236 10.24 16.5 11.11 16.5 12C16.4986 13.1931 16.024 14.3369 15.1804 15.1805C14.3368 16.0241 13.193 16.4986 12 16.5Z",
    fill: "#B4B6B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpnEye);
export default __webpack_public_path__ + "static/media/opnEye.9ea433fe4e22540f9b37d8db567f5dee.svg";
export { ForwardRef as ReactComponent };